// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".terms-and-privacy[data-v-20e241e7]{width:100%;max-width:850px;margin:0 auto}.terms-and-privacy .terms-and-privacy__title[data-v-20e241e7]{margin-bottom:30px}.terms-and-privacy .terms-and-privacy__content[data-v-20e241e7]{margin-top:10px}", ""]);
// Exports
module.exports = exports;
